import { render, staticRenderFns } from "./NotaDeIngreso.vue?vue&type=template&id=20c800b6&scoped=true&"
import script from "./NotaDeIngreso.vue?vue&type=script&lang=js&"
export * from "./NotaDeIngreso.vue?vue&type=script&lang=js&"
import style0 from "./NotaDeIngreso.vue?vue&type=style&index=0&id=20c800b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c800b6",
  null
  
)

export default component.exports